module.exports = __webpack_public_path__ + "img/open_gable.abe84c48.jpg";